var map = {
	"./aboutUs": "xdld",
	"./aboutUs.vue": "xdld",
	"./article": "bnxb",
	"./article.vue": "bnxb",
	"./chargeMode": "ghQS",
	"./chargeMode.vue": "ghQS",
	"./common/footer": "2q2k",
	"./common/footer.vue": "2q2k",
	"./common/header": "+h7Z",
	"./common/header.vue": "+h7Z",
	"./components/videoDialog": "+zaQ",
	"./components/videoDialog.vue": "+zaQ",
	"./hkWellsoon": "4fL5",
	"./hkWellsoon.vue": "4fL5",
	"./home": "P1Pu",
	"./home.vue": "P1Pu",
	"./news": "aoOn",
	"./news.vue": "aoOn",
	"./pharmacopoeia": "Dqve",
	"./pharmacopoeia.vue": "Dqve",
	"./storeInformation": "sRTt",
	"./storeInformation.vue": "sRTt"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Rx/Q";


//////////////////
// WEBPACK FOOTER
// ./src/view ^\.\/.*$
// module id = Rx/Q
// module chunks = 0